import { useEffect, useRef } from 'react';

let lastTime: number | null = null;
const INTERVAL = 1000;
const DELAY = INTERVAL * 2;

export const useDetectWakeUpMode = (callback: () => void, isRun: boolean): void => {
  const intervalRef = useRef<null | ReturnType<typeof setInterval>>(null);

  useEffect(() => {
    if (!isRun) {
      return;
    }

    lastTime = Date.now();

    intervalRef.current = setInterval(() => {
      const now = Date.now();
      const diff = now - lastTime!;
      lastTime = now;

      if (diff > DELAY) {
        callback();
      }
    }, INTERVAL);

    return (): void => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [callback, isRun]);
};
